import { toast } from 'react-toastify';

const defaultOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
};

export const notifySuccess = (message) => {
  toast.success(message, defaultOptions);
};

export const notifyError = (message) => {
  toast.error(message, defaultOptions);
};

export const notifyWarning = (message) => {
  toast.warn(message, defaultOptions);
};

export const notifyInfo = (message) => {
  toast.info(message, defaultOptions);
};
